export type QueuedRequest = { id: string; path: string; method: string; body?: unknown };
const STORE = "rubymax-outbox";
const DB = "rubymax-local";

/** Paths that belonged to the removed nutrition features — discard, do not replay. */
const retired = (path: string) => /^(foods|recipes|diary|barcode)(\/|$)/.test(path) || path === "export/diary.csv";

function open() {
  return new Promise<IDBDatabase>((resolve, reject) => {
    const request = indexedDB.open(DB, 1);
    request.onupgradeneeded = () => request.result.createObjectStore(STORE, { keyPath: "id" });
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}
export async function queue(request: Omit<QueuedRequest, "id">) {
  if (retired(request.path)) return { ...request, id: crypto.randomUUID() };
  const db = await open();
  const item = { ...request, id: crypto.randomUUID() };
  await new Promise<void>((resolve, reject) => {
    const transaction = db.transaction(STORE, "readwrite");
    transaction.objectStore(STORE).put(item); transaction.oncomplete = () => resolve(); transaction.onerror = () => reject(transaction.error);
  });
  return item;
}
export async function pending() {
  const db = await open();
  return new Promise<QueuedRequest[]>((resolve, reject) => {
    const request = db.transaction(STORE).objectStore(STORE).getAll(); request.onsuccess = () => resolve(request.result); request.onerror = () => reject(request.error);
  });
}
export async function remove(id: string) {
  const db = await open();
  await new Promise<void>((resolve, reject) => { const tx = db.transaction(STORE, "readwrite"); tx.objectStore(STORE).delete(id); tx.oncomplete = () => resolve(); tx.onerror = () => reject(tx.error); });
}
/** Drop queued nutrition writes left over from older app versions. */
export async function dropRetired() {
  const entries = await pending();
  await Promise.all(entries.filter((entry) => retired(entry.path)).map((entry) => remove(entry.id)));
}
